@if (isRedirecting) {
    <!-- Show loading while redirecting to MAG or backend for authentication -->
    <div class="redirect-loading">
        <div class="redirect-content">
            <i class="fa-solid fa-circle-notch fa-spin fa-2x"></i>
            <p>Redirecting to login...</p>
        </div>
    </div>
} @else {
    @if (bannerList.length > 0) {
        <div class="maintenance-banner-container">
            @for (banner of bannerList; track banner.uniqueID) {
                <div class="maintenance-banner">
                    <div class="maintenance-banner-content">
                        <strong><i class="fa-solid fa-bullhorn"></i> {{ banner.title }}</strong>
                        <span>{{ banner.description }}</span>
                    </div>
                    <button class="maintenance-banner-close" (click)="dismissBanner(banner.uniqueID)">
                        <i class="fa-solid fa-xmark"></i>
                    </button>
                </div>
            }
        </div>
    }
    <app-header></app-header>
    <router-outlet></router-outlet>

    <tour-step-template></tour-step-template>
    @if ((loadingService.isLoading$ | async) && !loadingService.isDisabled()) {
        <div class="fa-3x">
            <i class="centered-spinnner fa-solid fa-circle-notch fa-spin fa-spin-pulse"></i>
            <div class="spinner-backdrop"></div>
        </div>
    }
}
